import React, { Component } from 'react';

import * as basicLightBox from 'basiclightbox';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { MEDIA_TYPE } from '_enums/media-types';
import { Translate } from '_translations';

class Table extends Component {
  constructor() {
    super();
    this.lightboxes = [];
  }

  render() {
    let isFinalists = false;
    if (this.props.selectedCountry && this.props.selectedCountry.value === '(top_per_region)') {
      isFinalists = true;
    }

    return (
      <React.Fragment>
        <table className="leaderboard__table">
          <tbody>
            <tr>
              <th><Translate resourceString="Thunderbolt.Leaderboard.Rank" /></th>
              <th><Translate resourceString="Thunderbolt.Leaderboard.Name" /></th>
              <th><Translate resourceString="Thunderbolt.Leaderboard.Time" /></th>
              <th><Translate resourceString="Thunderbolt.Leaderboard.Trade" /></th>
              {isFinalists && (
                <th><Translate resourceString="Thunderbolt.Leaderboard.Region" /></th>
              )}
              {!isFinalists && (
                <th><Translate resourceString="Thunderbolt.Leaderboard.Country" /></th>
              )}
              <th className="video-column"></th>
            </tr>
            {this.props.leaderboard.content.leaderboard.map(x => this.renderRow(x, isFinalists))}
          </tbody>
        </table>

        {this.props.leaderboard.content.canLoadMore === true &&
          (
            <button className="thunderbolt-button" onClick={this.props.loadMore}>
              <span><Translate resourceString="LoadMore" /></span>
            </button>
          )
        }
      </React.Fragment>
    );
  }

  renderRow(row, isFinalists) {
    let rankValue = row.cultureRank;
    if (isFinalists) {
      rankValue = row.resultSetRank;
    }

    let displayRank = (<td>{rankValue}</td>);
    let hasFirstRank = false;

    if (rankValue === 1) {
      displayRank = this.getFirstPlaceRow(true);
      hasFirstRank = true;
    }

    return (
      <tr key={row.rankValue} className={hasFirstRank ? 'fix-height' : ''}>
        {displayRank}
        <td>{row.firstName}</td>
        <td>{row.recordedTime}</td>
        <td>{row.trade}</td>
        {isFinalists && (
          <th>{row.regionName}</th>
        )}
        {!isFinalists && (
          <td><span className={`flag ${row.cultureCode}`}></span> </td>
        )}
        <td className="video-column">{this.renderVideoButton(row)}</td>
      </tr>
    );
  }

  getFirstPlaceRow(global) {
    let className = 'winning';
    if (global === false) {
      className = 'culture-winning';
    }

    return (
      <td>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.146 27.782" className={className}>
          <path id="e892" d="M10.573,11.441a7.934,7.934,0,0,0-3.178.636,8.212,8.212,0,0,0-4.341,4.356,8.133,8.133,0,0,0,1.752,8.945A8.61,8.61,0,0,0,7.4,27.131a8.044,8.044,0,0,0,6.341,0,8.555,8.555,0,0,0,2.6-1.752,8.193,8.193,0,0,0,1.752-8.945,8.171,8.171,0,0,0-4.356-4.356A7.968,7.968,0,0,0,10.573,11.441Zm0,15.131a6.689,6.689,0,0,1-2.682-.543,7.154,7.154,0,0,1-2.2-1.473,6.875,6.875,0,0,1-2.031-4.9A6.689,6.689,0,0,1,4.2,16.976,6.835,6.835,0,0,1,5.69,14.79a7.154,7.154,0,0,1,2.2-1.473,6.9,6.9,0,0,1,5.364,0,7.154,7.154,0,0,1,2.2,1.473,6.835,6.835,0,0,1,1.488,2.186,6.689,6.689,0,0,1,.543,2.682,6.875,6.875,0,0,1-2.031,4.9,7.154,7.154,0,0,1-2.2,1.473A6.689,6.689,0,0,1,10.573,26.573ZM14.666,4.9,17.488,0H3.659L6.511,4.9Zm1.488,8.341,4.992-8.217L17.8.155,11.5,11.224a6.8,6.8,0,0,1,3.349,1.1ZM9.643,11.162,3.349.155,0,5.023l4.868,8.372,1.256-.961A7.385,7.385,0,0,1,9.643,11.162ZM9.457,17.8a3.746,3.746,0,0,1-.543.357,4.4,4.4,0,0,1-.512.233V19.5a4.284,4.284,0,0,0,.853-.388,4.6,4.6,0,0,0,.729-.543v4.682h1.24V16.744h-.992a1.61,1.61,0,0,1-.295.558A4.285,4.285,0,0,1,9.457,17.8Z" />
        </svg>
      </td>
    );
  }

  createVideoLightbox = (e, url) => {
    e.stopPropagation();

    const options = {
      onShow: () => disableBodyScroll(),
      onClose: () => enableBodyScroll(),
    };

    const lightbox = basicLightBox.create(`
      <video controls autoplay>
        <source src="${url}">
      </video>
    `, options);

    this.lightboxes.push(lightbox);
    lightbox.show();
  }

  renderVideoButton = (rowData) => {
    if (!rowData.mediaItems) {
      return null;
    }

    const video = rowData.mediaItems.find(x => x.itemType === MEDIA_TYPE.VIDEO);
    if (video) {
      return (
        <button onClick={e => this.createVideoLightbox(e, video.url)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none" />
            <path fill="#db011c" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
          </svg>
        </button>
      );
    }

    return null;
  };
}

export default Table;
